import cn from 'classnames';
import { type ReactNode, useState } from 'react';
import { SearchVerticalConfig, type Vertical } from 'shared/search/common/config';

import styles from './HeroBanner.module.css';

interface HeroBannerProps {
    vertical: Vertical;
    children?: ReactNode;
    unleash?: Record<string, boolean> | null; // cannot be just undefined as that is not serializable (toggles are returned from getSSP)
}

export const HeroBanner = ({ vertical, unleash, children }: HeroBannerProps) => {
    const [hasError, setHasError] = useState(false);

    const base = 'https://images.finncdn.no/dynamic';
    const defaultImage = `${base}/320w_webp/travel/frontpage/herobanner_${vertical}.jpg`;

    return (
        <div className={cn('', styles['hero-banner'], styles[`hero-banner--${vertical}`])}>
            {unleash?.vioWhitelabel && vertical === SearchVerticalConfig.hotel.vertical ? (
                /*
                TODO should this be used instead? The diff is the border and background colours.
                absolute w-full top-0 p-12 whitespace-nowrap pointer-events-none border border-l-4 rounded-4 s-text s-border-positive-subtle s-border-l-positive s-bg-positive-subtle  z-10
             */
                <p className="flex absolute w-full top-0 p-12 whitespace-nowrap pointer-events-none border border-l-4 rounded-4 s-text bg-[--w-color-callout-background] border-[--w-color-callout-border] z-10">
                    <span className=" mr-8  s-icon-positive">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M11.3095 5.37039C11.3095 5.37039 11.3095 3.39023 13.2897 3.39023C15.2698 3.39023 15.2698 1.41006 15.2698 1.41006M9.32932 0.75V2.73017M15.2698 8.67068L16.5899 9.99079M15.2698 6.03045L17.25 5.37039M3.89128 7.85303L10.147 14.1087M5.7906 15.6929L2.30715 12.2094M0.78902 16.3867L5.12146 4.47437C5.1583 4.3726 5.22025 4.28178 5.30155 4.21033C5.38285 4.13889 5.48088 4.08913 5.58654 4.06568C5.6922 4.04223 5.80208 4.04584 5.90597 4.07618C6.00987 4.10651 6.10442 4.1626 6.18085 4.23922L13.7616 11.82C13.838 11.8965 13.8939 11.991 13.9241 12.0949C13.9542 12.1987 13.9577 12.3085 13.9342 12.414C13.9107 12.5196 13.8609 12.6175 13.7895 12.6987C13.7181 12.7799 13.6273 12.8417 13.5256 12.8785L1.61327 17.211C1.49823 17.253 1.37357 17.2613 1.25399 17.2348C1.1344 17.2084 1.02485 17.1484 0.938251 17.0617C0.851648 16.9751 0.791592 16.8656 0.765154 16.746C0.738716 16.6264 0.746996 16.5018 0.78902 16.3867Z"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"></path>
                        </svg>
                    </span>
                    Heisann! Hotellsøket har nå fått ny drakt. God tur!
                </p>
            ) : null}
            <div
                className={cn(styles['hero-banner__image-wrapper'], styles[`hero-banner__image-wrapper--${vertical}`], {
                    [styles['hero-banner__image-wrapper--error']]: hasError,
                })}>
                <img
                    className={cn(styles['hero-banner__image'], styles[`hero-banner__image--${vertical}`])}
                    srcSet={`
                            ${base}/320w_webp/travel/frontpage/herobanner_${vertical}.jpg 320w,
                            ${base}/640w_webp/travel/frontpage/herobanner_${vertical}.jpg 640w,
                            ${base}/960w_webp/travel/frontpage/herobanner_${vertical}.jpg 960w,
                            ${base}/1280w_webp/travel/frontpage/herobanner_${vertical}.jpg 1280w
                        `}
                    sizes="100vw"
                    src={defaultImage}
                    onError={() => setHasError(true)}
                    alt=""
                />
            </div>
            <div className={styles['hero-banner__content-wrapper']}>{children}</div>
        </div>
    );
};
